import { Card, Flex, Skeleton } from 'antd'

const FormSkeleton = () => (
  <div className="pb-5" aria-busy="true" aria-label="Loading form">
    <div className="bg-white shadow-lg rounded-lg p-5">
      <div className="mb-4">
        <Skeleton.Input active size="small" className="mb-1" />
        <Skeleton.Input active />
      </div>
      <Skeleton.Input active block className="mb-3" />
      <Flex gap="1rem">
        <Skeleton.Input active block />
        <Skeleton.Input active block />
      </Flex>
      <div className="mt-4">
        <Card loading />
      </div>
    </div>
  </div>
)

export default FormSkeleton
